// extracted by mini-css-extract-plugin
module.exports = {"arrowBtn":"BackButton_arrowBtn__26GwO","btn":"BackButton_btn__2hypc"};